import React from 'react'
import UserProfileSetup from '../../components/Users/ProfileSetup/UserProfileSetup'

const AccountSetup = () => {
  return (
    <UserProfileSetup/>
  )
}

export default AccountSetup